import types from "../actionTypes";

export function showSuccessMessage(value, message) {
  return {
    type: types.SHOW_SUCCESS_MESSAGE,
    isSuccessMessage: value,
    message: message,
    isErrorMessage: false,
  };
}

export function showErrorMessage(value, message) {
  return {
    type: types.SHOW_ERROR_MESSAGE,
    isErrorMessage: value,
    message: message,
    isSuccessMessage: false,
  };
}

export function showValidationErrorMessage(value, labelKey, message) {
  return {
    type: types.SHOW_VALIDATION_ERROR_MESSAGE,
    isValidationOccur: value,
    labelKey: labelKey,
    message: message,
    isErrorMessage: false,
    isSuccessMessage: false,
  };
}

export function showDefaultErrorMessage(value) {
  return {
    type: types.SHOW_DEFAULT_ERROR_MESSAGE,
    isDefaultErrorMessage: value,
    isSuccessMessage: false,
  };
}
